import { Phone, MessageSquare, Mail, Trash2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const STATUSES = ["new", "contacted", "scheduled", "completed", "cancelled"];
const COLORS = { new: "#1bb4f2", contacted: "#f59e0b", scheduled: "#a78bfa", completed: "#10b981", cancelled: "#ef4444" };
const digits = (p) => (p || "").replace(/[^\d+]/g, "");

export const QuoteCard = ({ quote: x, onStatus, onDelete }) => (
  <div className="border border-white/10 bg-[#0b0d12] p-5 md:p-6 grid md:grid-cols-12 gap-5" data-testid={`quote-row-${x.id}`}>
    <div className="md:col-span-4">
      <div className="flex items-center gap-2">
        <span className="h-2 w-2 rounded-full" style={{ background: COLORS[x.status] }} />
        <p className="font-semibold text-lg">{x.name}</p>
      </div>
      <p className="mt-1 text-sm text-slate-400">{new Date(x.created_at).toLocaleString()}</p>
      <div className="mt-4 flex gap-2">
        <a href={`tel:${digits(x.phone)}`} className="h-9 px-3 inline-flex items-center gap-2 border border-white/15 hover:border-[#1bb4f2] text-sm" data-testid={`quote-call-${x.id}`}><Phone className="h-3.5 w-3.5" />{x.phone}</a>
        <a href={`sms:${digits(x.phone)}`} className="h-9 w-9 grid place-items-center border border-white/15 hover:border-[#1bb4f2]" aria-label="Text" data-testid={`quote-sms-${x.id}`}><MessageSquare className="h-3.5 w-3.5" /></a>
        {x.email && <a href={`mailto:${x.email}`} className="h-9 w-9 grid place-items-center border border-white/15 hover:border-[#1bb4f2]" aria-label="Email" data-testid={`quote-email-${x.id}`}><Mail className="h-3.5 w-3.5" /></a>}
      </div>
    </div>
    <div className="md:col-span-5 text-sm space-y-1.5">
      <p><span className="text-slate-400">Vehicle:</span> {x.vehicle_type}{x.vehicle ? ` — ${x.vehicle}` : ""}</p>
      <p><span className="text-slate-400">Services:</span> {(x.services || []).join(", ")}</p>
      <p><span className="text-slate-400">Where:</span> {{ mobile: "Mobile", pickup: "Pickup & drop-off", "in-shop": "In-shop" }[x.location] || x.location}{x.location !== "in-shop" && x.address ? ` — ${x.address}` : ""}</p>
      {x.preferred_date && <p><span className="text-slate-400">Preferred:</span> {x.preferred_date}</p>}
      {x.notes && <p className="text-slate-300 italic">"{x.notes}"</p>}
    </div>
    <div className="md:col-span-3 flex md:flex-col gap-2 md:items-end">
      <Select value={x.status} onValueChange={(v) => onStatus(x.id, v)}>
        <SelectTrigger className="w-40 rounded-none bg-transparent capitalize" data-testid="quote-status-select"><SelectValue /></SelectTrigger>
        <SelectContent className="bg-[#0b0d12] border-white/10 text-white">
          {STATUSES.map((s) => <SelectItem key={s} value={s} className="capitalize" data-testid={`status-option-${s}`}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
      <button onClick={() => onDelete(x.id)} className="h-9 w-9 grid place-items-center border border-white/15 hover:border-red-500 hover:text-red-400" aria-label="Delete" data-testid={`quote-delete-${x.id}`}><Trash2 className="h-4 w-4" /></button>
    </div>
  </div>
);
